// ============================================================================
// fileBytes.ts — нормализация поля proto `bytes` из ответов SDK.
// Transport grpc-web отдаёт Uint8Array; connect-JSON — base64-строку.
// ЕДИНАЯ точка преобразования (SRP): байты для Blob / base64 для data URL.
// ============================================================================

/** Байты файла из значения поля `data` (Uint8Array | base64-строка) */
export function fileBytes(data: unknown): Uint8Array {
  if (data instanceof Uint8Array) return data;
  if (typeof data === 'string' && data.length > 0) {
    let s = data.replace(/-/g, '+').replace(/_/g, '/');
    while (s.length % 4 !== 0) s += '=';
    try {
      const bin = atob(s);
      const u8 = new Uint8Array(bin.length);
      for (let i = 0; i < bin.length; i++) u8[i] = bin.charCodeAt(i);
      return u8;
    } catch {
      return new Uint8Array(0);
    }
  }
  return new Uint8Array(0);
}

/** base64 (для data URL) из значения поля `data` */
export function fileBase64(data: unknown): string {
  if (typeof data === 'string' && data.length > 0) {
    let s = data.replace(/-/g, '+').replace(/_/g, '/');
    while (s.length % 4 !== 0) s += '=';
    return s;
  }
  const u8 = fileBytes(data);
  let s = '';
  const CH = 0x8000;
  for (let i = 0; i < u8.length; i += CH) {
    s += String.fromCharCode.apply(null, Array.from(u8.subarray(i, i + CH)) as unknown as number[]);
  }
  return btoa(s);
}

/**
 * Blob из байтов (копия в ArrayBuffer — типобезопасно для `new Blob([...])`,
 * т.к. Uint8Array<ArrayBufferLike> не всегда BlobPart в строгом TS).
 */
export function bytesToBlob(data: unknown, type = 'application/octet-stream'): Blob {
  const u8 = fileBytes(data);
  const buf = new ArrayBuffer(u8.length);
  new Uint8Array(buf).set(u8);
  return new Blob([buf], { type });
}
